/**
 * Standard `assert()` function, aka. `invariant()`.
 *
 * @example
 *   assert(data !== null, 'Expected data to be available')
 *
 *   assert(number > 0, 'Number must be positive')
 *
 * @param condition Value to check. Narrowed to truthy after the call.
 * @param message What the caller was assuming, and ideally which id broke it.
 *
 * @throws {Error} Throws if given condition is false.
 */
export function assert(condition: unknown, message: string): asserts condition {
  if (condition) {
    return
  }

  throw new Error(message)
}

/**
 * Utility for making `switch` statements safer with exhaustive matching.
 *
 * While a check for `never` can be done inline, we prefer to throw rather than
 * returning and relying on undefined behavior. This utility makes reusable and
 * consistent.
 */
export function assertExhaustive(value: never): never {
  throw new Error(`Unhandled value: ${String(value)}`)
}
